// extracted by mini-css-extract-plugin
export default {"sub-li":"SubMenu_sub-li__D9ocZ","redirect_icon":"SubMenu_redirect_icon__By7q1","redirect":"SubMenu_redirect__D7WYN","sub_nav":"SubMenu_sub_nav__xcov+"};